//
// DASHBOARD - EVENTS
//
var fn_dashboard = function () {
  $('.block-dashboard-events-item .close').click(function(){
    $(this).parent().addClass('hidden');
    $(this).parent().hide();
    $('.block-dialog-desinscription-event').show();
    $('.block-dashboard-events-item .close').attr("disabled","disabled");
  });

  $('.block-dialog-desinscription-event .btn-cancel').click(function(){
    $('.block-dialog-desinscription-event').hide();
    $('.block-dashboard-events-item.hidden').show();
    $('.block-dashboard-events-item').removeClass('hidden');
    $('.block-dashboard-events-item .close').removeAttr('disabled');
  });
}